module.exports = __webpack_public_path__ + "static/media/LOGO-1-RGB.d08a73c5.png";